import { c as M } from "./clsx-OuTLNxxd.mjs.js";
import { r as f, j as e, c as E } from "./client-BkmPNNjT.mjs.js";
import { L as w } from "./layout-CEgW1KBl.mjs.js";
const C = async (d, s) => fetch("/cart/change", {
  method: "POST",
  headers: {
    "Content-Type": "application/json"
  },
  body: JSON.stringify({
    id: d,
    quantity: s
  })
}).then((n) => {
  if (n.ok)
    return n;
  throw new Error(n.statusText);
}), I = ({
  decrementLabel: d = "Decrease",
  incrementLabel: s = "Increase",
  inputLabel: n = "Quantity",
  decrementIcon: i = "-",
  incrementIcon: a = "+",
  lineKey: o,
  min: c = 1,
  max: r,
  step: u = 1,
  onChange: b,
  defaultValue: x
}) => {
  const [m, p] = f.useState(x ?? 1), [j, L] = f.useState(), [y, v] = f.useState(!1), g = (l, t) => {
    p(t), L(void 0), v(!0), C(o, t).then(() => {
      b && b(l, {
        lineKey: o,
        quantity: t
      });
    }).catch((h) => {
      console.error("[cart:change:quantity]", h.message), L(h.message);
    }).finally(() => {
      v(!1);
    });
  }, T = (l) => {
    const t = Math.max(m - u, c);
    g(l, t);
  }, N = (l) => {
    const t = r ? Math.min(m + u, r) : m + u;
    g(l, t);
  }, k = (l) => {
    const t = Number(l.target.value);
    if (isNaN(t) || t === m)
      return;
    let h = t;
    t < c ? h = c : r && t > r && (h = r), g(l, h);
  };
  return /* @__PURE__ */ e.jsxs("div", {
    className: M("flex border rounded-md h-full", j ? "border-red-500" : "border-black"),
    title: j,
    children: [/* @__PURE__ */ e.jsxs("button", {
      type: "button",
      disabled: m <= c || y,
      className: "cart-item__decrement pl-3 disabled:opacity-25",
      onClick: T,
      children: [/* @__PURE__ */ e.jsx("span", {
        className: "sr-only",
        children: d
      }), /* @__PURE__ */ e.jsx("span", {
        dangerouslySetInnerHTML: {
          __html: i
        }
      })]
    }), /* @__PURE__ */ e.jsx("input", {
      className: "cart-item__quantity text-center w-full disabled:opacity-25",
      inputMode: "numeric",
      name: "quantity",
      disabled: y,
      value: m,
      min: c,
      max: r,
      step: u,
      "aria-label": n,
      onChange: (l) => {
        const t = Number(l.target.value);
        isNaN(t) || p(t);
      },
      onBlur: k
    }), /* @__PURE__ */ e.jsxs("button", {
      type: "button",
      disabled: !!(r && m >= r) || y,
      className: "cart-item__increment pr-3 disabled:opacity-25",
      onClick: N,
      children: [/* @__PURE__ */ e.jsx("span", {
        className: "sr-only",
        children: s
      }), /* @__PURE__ */ e.jsx("span", {
        dangerouslySetInnerHTML: {
          __html: a
        }
      })]
    })]
  });
};
class q extends HTMLElement {
  connectedCallback() {
    const s = this.querySelector("[data-decrement-icon]"), n = this.querySelector("[data-increment-icon]"), i = this.dataset.decrementLabel, a = this.dataset.incrementLabel, o = this.dataset.inputLabel, c = this.dataset.lineKey, r = this.dataset.ajax ? this.dataset.ajax === "true" : !0, u = (x, m) => {
      r || location.reload(), window.dispatchEvent(new CustomEvent("cart:change:quantity", {
        detail: {
          ...m,
          originalEvent: x
        },
        bubbles: !0
      }));
    };
    E.createRoot(this).render(/* @__PURE__ */ e.jsx(w, {
      children: c ? /* @__PURE__ */ e.jsx(I, {
        decrementLabel: i,
        incrementLabel: a,
        inputLabel: o,
        lineKey: c,
        defaultValue: Number(this.dataset.defaultValue) ?? void 0,
        min: Number(this.dataset.min) || 1,
        max: Number(this.dataset.max) ?? void 0,
        step: Number(this.dataset.step) ?? void 0,
        decrementIcon: s?.innerHTML,
        incrementIcon: n?.innerHTML,
        onChange: u
      }) : /* @__PURE__ */ e.jsx("p", {
        children: "(Line Key is required)"
      })
    }));
  }
}
customElements.get("cart-quantity") || customElements.define("cart-quantity", q);
const S = ({
  lineKey: d,
  children: s,
  onSuccess: n
}) => {
  const [i, a] = f.useState(!1), o = () => {
    a(!0), C(d, 0).then(() => {
      n?.();
    }).catch((c) => {
      console.error("[cart:remove:item]", c.message);
    }).finally(() => {
      a(!1);
    });
  };
  return i ? /* @__PURE__ */ e.jsx("button", {
    className: "btn btn-link",
    disabled: !0,
    children: /* @__PURE__ */ e.jsx("span", {
      children: "Removing..."
    })
  }) : /* @__PURE__ */ e.jsx("button", {
    className: "btn btn-link",
    onClick: () => o(),
    dangerouslySetInnerHTML: {
      __html: s
    }
  });
};
class H extends HTMLElement {
  connectedCallback() {
    const s = this.dataset.confirmText, n = this.dataset.cancelText, i = this.dataset.lineKey, a = this.dataset.ajax ? this.dataset.ajax === "true" : !0, o = () => {
      a || location.reload(), window.dispatchEvent(new CustomEvent("cart:remove:item", {
        detail: {
          lineKey: i
        }
      }));
    };
    E.createRoot(this).render(/* @__PURE__ */ e.jsx(w, {
      children: i ? /* @__PURE__ */ e.jsx(S, {
        lineKey: i,
        confirmText: s,
        cancelText: n,
        onSuccess: o,
        children: this.innerHTML
      }) : /* @__PURE__ */ e.jsx("p", {
        children: "(Line Key is required)"
      })
    }));
  }
}
customElements.get("cart-remove-item") || customElements.define("cart-remove-item", H);
class _ extends HTMLElement {
  connectedCallback() {
    const s = (this.dataset.events || "").split(/,\s*/).filter((i, a, o) => o.indexOf(i) === a), n = this.dataset.src;
    if (!n || !this.id) {
      console.warn("[ajax-component]", "src & id is required");
      return;
    }
    for (const i of s)
      window.addEventListener(i, () => {
        fetch(n).then((a) => {
          a.ok ? a.text().then((o) => {
            const r = new DOMParser().parseFromString(o, "text/html").getElementById(this.id);
            r && (this.innerHTML = r.innerHTML);
          }) : console.error("[ajax-component]", "Failed to fetch src", a.statusText);
        });
      });
  }
}
customElements.get("ajax-component") || customElements.define("ajax-component", _);
class R extends HTMLAnchorElement {
  connectedCallback() {
    this.addEventListener("click", (s) => {
      window.history.length > 1 && document.referrer && new URL(document.referrer).origin === window.location.origin && (s.preventDefault(), window.history.back());
    });
  }
}
customElements.get("go-back") || customElements.define("go-back", R, {
  extends: "a"
});
